import { render, staticRenderFns } from "./Review_opponent.vue?vue&type=template&id=89a21162&scoped=true"
import script from "./Review_opponent.vue?vue&type=script&lang=js"
export * from "./Review_opponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a21162",
  null
  
)

export default component.exports